import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../../services/api-client.service';
import {UserService} from '../services/user.service';
import {ConstantsService} from '../../../../services/constants.service';
import {DirectoryService} from '../../../../services/directory.service';
import {UrlService} from '../../../../services/url.service';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'reset-password-modal',
    templateUrl: './reset-password-modal.component.html',
    styleUrls: [
        '../../../profile/change-password/change-password.component.scss',
        './reset-password-modal.component.scss'
    ]
})
export class ResetPasswordModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    newPassword = '';
    newPasswordConfirmation = '';

    isActiveFirst: boolean = false;
    isActiveSecond: boolean = false;

    lengthPassed: boolean = false;
    upperPassed: boolean = false;
    lowerPassed: boolean = false;
    numberPassed: boolean = false;

    isEqualPasswords: boolean = false;
    isRulesPassed: boolean = false;

    constructor(
        public api: ApiClientService,
        public userService: UserService,
        public urlService: UrlService,
        public directoryService: DirectoryService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                this.userService.showUserPasswordResetModal = false;
                this.userService.userInResetPasswordModal = null;
                this.directoryService.showResetPasswordModal = false;
                this.urlService.modalClosed.emit();
            });
        } else {
            this.userService.showUserPasswordResetModal = false;
            this.userService.userInResetPasswordModal = null;
            this.directoryService.showResetPasswordModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (form.invalid) {
            if (!this.newPassword) toastr.warning('Password must not be empty');
            if (!this.newPasswordConfirmation) toastr.warning('Password Confirmation must not be empty');
            return;
        }
        if (!this.isRulesPassed) return toastr.warning('All rules must be respected!');
        if (!this.isEqualPasswords) return toastr.warning('The password fields must match!');

        const data: any = {
            plainPassword: {
                first:  this.newPassword,
                second: this.newPasswordConfirmation
            }
        };

        this.disabledSubmit = true;

        if (this.userService.userInResetPasswordModal.id) {
            const url = `/api/users/change_password_by_admin/${this.userService.userInResetPasswordModal.id}.json`;
            this.api.patch('oauthUrl', url, data).subscribe(
                () => this.updateView('Password has been successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Password update failed');
                }
            );
        } else {
            toastr.error('Oops. Something went wrong.');
            this.disabledSubmit = false;
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.hideModal();
    }

    onFocusInput(event) {
        this.validate(event);

        if (event.target.id === 'user_password_first') {
            this.isActiveFirst = true;
            this.isActiveSecond = false;
        } else {
            this.isActiveFirst = false;
            this.isActiveSecond = true;
        }
    }

    onBlurInput(event) {
        this.resetRules();
        this.isActiveFirst = false;
        this.isActiveSecond = false;
    }

    validate(event) {
        this.isEqualPasswords = (this.newPassword && this.newPasswordConfirmation
                                 && (this.newPassword === this.newPasswordConfirmation));
        event.target.value = event.target.value.trim();
        const value = event.target.value;
        this.resetRules();

        if (value.length > 5) {
            this.lengthPassed = true;
        }
        if (/[A-Z]/.test(value)) {
            this.upperPassed = true;
        }
        if (/[a-z]/.test(value)) {
            this.lowerPassed = true;
        }
        if (/[0-9]/.test(value)) {
            this.numberPassed = true;
        }

        this.isRulesPassed = this.lengthPassed && this.upperPassed && this.lowerPassed && this.numberPassed;
    }

    resetRules() {
        this.lengthPassed = false;
        this.upperPassed = false;
        this.lowerPassed = false;
        this.numberPassed = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/reset-password-modal/reset-password-modal.component.ts